import React from 'react';
import { Square } from './Square';
import { Container } from './styles';
import { iCell, iBox, iSquare } from '../../../../interfaces/sudoku';
import { useSudoku } from '../../SudokuContext';

interface BoardProps {
  cellSolution: iCell[];
  bigSquare: iBox;
  alphabet: string;
  savedMatrix: iSquare[][];
}

export const Board: React.FC<BoardProps> = ({
  cellSolution,
  bigSquare,
  alphabet,
  savedMatrix,
}: BoardProps) => {
  const { height, width, isSudokuFinished } = useSudoku();

  let rowValue = '';

  return (
    <Container>
      {[...Array(height)].map((_, row) => {
        return (
          <div key={row * width} className="row">
            {[...Array(width)].map((_, column) => {
              if (cellSolution[row * height + column]?.attributes) {
                const { hint, solution, x } =
                  cellSolution[row * width + column]?.attributes;

                if (savedMatrix && isSudokuFinished) {
                  rowValue = savedMatrix[row][column]?.value
                    ? savedMatrix[row][column].value
                    : '';
                }

                if (Number(x) === row + 1) {
                  return (
                    <Square
                      key={(row + 1) * width + column}
                      x={row}
                      y={column}
                      alphabet={alphabet}
                      value={rowValue}
                      isHint={hint ? true : false}
                      boxWidth={Number(bigSquare['box-width'])}
                      boxHeight={Number(bigSquare['box-height'])}
                      isSquareSolution={solution}
                    />
                  );
                }
              }

              return null;
            })}
          </div>
        );
      })}
    </Container>
  );
};
